
import dayjs from "dayjs";
import { Component, Vue, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol, formDownload } from "@common/src/utils/tools";
import SettlementCycleDialog from "./components/settlement-cycle-dialog.vue";
import ReceivePaymentDialog from "./components/receive-payment-dialog.vue";
import _ from "lodash-es";

const finance = namespace("finance");
const base = namespace("base");

@Component({ components: { SettlementCycleDialog, ReceivePaymentDialog } })
@Table("loadListData")
export default class DeferredPayment extends Vue {
  @base.Action getDictionaryList;
  @finance.Action queryDeferredPaymentList;

  @Ref("SettlementCycleDialog") SettlementCycleDialog;
  @Ref("ReceivePaymentDialog") ReceivePaymentDialog;

  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  searchForm = {
    customerName: "",
    payStatus: "",
    customerCode: "",
    payStatusList: [],
    onAccountTime: [],
    onAccountTimeBegin: "",
    onAccountTimeEnd: "",
    lastPayTimeBegin: "",
    lastPayTimeEnd: "",
    billingCycleStatus: ""
  };
  deferredPayList: any[] = [];
  receiptTypeList: any[] = [];
  get searchList() {
    return [
      {
        label: "挂账日期",
        type: "daterange",
        value: this.defaultOnAccounDate,
        prop: "onAccountTime",
        valueDistribute: ["onAccountTimeBegin", "onAccountTimeEnd"]
      },
      {
        label: "挂账收款日期",
        type: "daterange",
        value: this.defaultPaymentDate,
        prop: "lastPayTime",
        valueDistribute: ["lastPayTimeBegin", "lastPayTimeEnd"]
      },
      {
        label: "挂账状态",
        type: "select",
        selectList: this.cycleStatusList,
        value: this.defaultBillingCycleStatus,
        prop: "billingCycleStatus"
      },
      {
        label: "收款状态",
        type: "select",
        selectList: this.receivedStatusList,
        value: this.defaultpayStatus,
        prop: "payStatus"
      },
      {
        label: "挂账单号",
        type: "input",
        value: "",
        prop: "onAccountNo"
      },
      {
        label: "订单编号",
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: "客户姓名",
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: "客户手机号",
        type: "input",
        value: this.defaultMobile,
        prop: "customerMobile"
      },
      {
        label: "车牌号",
        type: "input",
        value: "",
        prop: "plateCode"
      }
    ];
  }

  urlCustomerName = "";
  defaultOnAccounDate = [];
  defaultPaymentDate = [];
  defaultBillingCycleStatus = "";
  defaultpayStatus = "";
  created() {
    this.getDictionaryList("on_account_billing_cycle_status").then(data => {
      this.cycleStatusList = data;
    });
    this.getDictionaryList("on_account_pay_status").then(data => {
      this.receivedStatusList = data;
    });

    this.init();
  }

  handleSearch(data) {
    this.searchForm.payStatusList = [];
    this.searchForm.customerCode = "";
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  sumData: any = {};
  listByCustomerCode = null;
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryDeferredPaymentList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(res => {
      this.sumData = {
        sumOnAccountAmount: res.data.sumOnAccountAmount,
        sumPayAmount: res.data.sumPayAmount,
        sumDueAmount: res.data.sumDueAmount,
        countDue: res.data.countDue,
        sumOverdueAmount: res.data.sumOverdueAmount,
        countOverdue: res.data.countOverdue
      };
      this.listByCustomerCode = res.data.customerCode || "";
      this.deferredPayList = res.data?.list || [];
      return res;
    });
  }

  handleLinkView(row) {
    const { href } = this.$router.resolve(`/finance/deferred-payment/detail/${row.onAccountNo}`);
    window.open(href);
  }
  cycleStatusList = [];
  receivedStatusList = [];
  defaultMobile = "";
  async init() {
    const { customerCode: urlCustomerCode, dashboard, mobile } = this.$route.query;
    if (urlCustomerCode) {
      this.searchForm.customerCode = urlCustomerCode as string;
      this.searchForm.payStatusList = ["10", "20"];
      this.defaultMobile = (mobile as string) || "";
    }
    const today = dayjs().format("YYYYMMDD");
    if (dashboard) {
      if (dashboard === "1") {
        this.defaultOnAccounDate = [today, today];
        this.searchForm.onAccountTimeBegin = today;
        this.searchForm.onAccountTimeEnd = today;
      } else if (dashboard === "2") {
        this.defaultPaymentDate = [today, today];
        this.searchForm.lastPayTimeBegin = today;
        this.searchForm.lastPayTimeEnd = today;
      } else if (dashboard === "3") {
        this.defaultpayStatus = "10";
        this.searchForm.payStatus = "10";
      } else if (dashboard === "4") {
        this.defaultpayStatus = "10";
        this.defaultBillingCycleStatus = "20";
        this.searchForm.payStatus = "10";
        this.searchForm.billingCycleStatus = "20";
      }
    }
    this.loadListData();
  }
  handleShowReceiveDialog(type, row) {
    if (type === "all") {
      if (Number(this.sumData.sumDueAmount) <= 0) {
        return this.$message.error("收款金额为0，无需收款。");
      }
      if (!this.listByCustomerCode) {
        this.allRepaymentTipsShow = true;
      } else {
        this.showSumData = _.pick(this.sumData, ["countDue", "sumDueAmount"]);
        this.filterParams = _.cloneDeep(this.searchForm);
        this.receiveScope = "multiple";
        this.ReceivePaymentDialog.open(this.listByCustomerCode);
      }
    } else {
      this.showSumData = {
        countDue: 1,
        sumDueAmount: row.duePayAmount
      };
      this.filterParams = {
        onAccountNo: row.onAccountNo
      };
      this.receiveScope = "single";
      this.ReceivePaymentDialog.open(row.customerCode);
    }
  }
  handleOpenCycleDialog() {
    this.SettlementCycleDialog.open();
  }
  allRepaymentTipsShow = false;
  showSumData = {};
  filterParams = {};
  receiveScope: "multiple" | "single" = "multiple";
  handleSkipPrompt() {
    this.allRepaymentTipsShow = false;
  }
  handleExportData() {
    formDownload(`${window.API_URL}/onAccount/download`, this.searchForm);
  }
}
